import React from "react";

import createBaseRenderer from "./createBaseRenderer";

import { Uzivatel } from "./ciselnik";
import { DateAktivita } from "./";

export default createBaseRenderer({
  name: "zadostPoznamkyItem",
  placeholderText: "Lorem ipsum dolor sit amen",
  content: ({ val }) => (
    <div className="b2b-ZadostPoznamkyItem">
      <div className="b2b-ZadostPoznamkyItem-label">
        <div className="b2b-ZadostPoznamkyItem-autor">
          <Uzivatel val={val.uzivatel} />
        </div>
        <div className="b2b-ZadostPoznamkyItem-datum">
          <DateAktivita val={val.datum} />
        </div>
      </div>
      <div className="b2b-ZadostiRowDetail-poznamkaText">{val.text}</div>
    </div>
  )
});
